import { Flex, Icon, IconProps, Loader, Text } from 'components/ui';
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { globalTheme } from 'styles/global-theme';

type ListingStatusButtonProps = {
  label: string;
  icon: IconProps['component'];
  onClick: (id: string) => void;
  isActive?: boolean;
  isLoading?: boolean;
  isSmall?: boolean;
  className?: string;
  hideIcon?: boolean;
  disabled?: boolean;
};

const StatusContent = styled.div<{
  isSmall?: boolean;
  hideIcon?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  max-width: ${({ hideIcon }) => (hideIcon ? `900px` : `80px`)};
  min-width: ${({ isSmall }) => (!isSmall ? `60px` : `0`)};
  width: 100%;
  align-items: center;
  text-align: center;
  flex-direction: column;
  gap: 4px;
  padding: ${({ isSmall }) => (isSmall ? `4px` : `${globalTheme.space[0]}`)};
  margin-top: ${({ isSmall }) => isSmall && `4px`};
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${({ disabled }) =>
      !disabled && globalTheme.colors.neutral};
  }

  @media screen and (max-width: ${breakpoints.small}) {
    &:hover {
      background-color: unset;
    }
  }
  border: ${({ hideIcon }) =>
    hideIcon && `1px solid ${globalTheme.colors.neutral}`};

  ${Text} {
    display: block;
    ${({ hideIcon }) =>
      hideIcon &&
      css`
        clear: both;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
      `}
  }

  &[data-active='true'] {
    background-color: ${globalTheme.colors.darkBlue};
    color: white;
  }
  &[aria-disabled='true'] {
    opacity: 0.6;
    cursor: no-drop;
  }
`;

const ListingStatusButton = ({
  icon,
  label,
  isLoading,
  onClick,
  isActive,
  isSmall,
  hideIcon,
  disabled,
}: ListingStatusButtonProps) => {
  return (
    <Flex
      key={label}
      direction='column'
      alignItems='center'
      justifyContent='space-between'
      wrap='wrap'
      gap={0}
    >
      <StatusContent
        aria-disabled={isLoading || disabled}
        data-active={isActive}
        isSmall={isSmall}
        onClick={() => !isLoading && !disabled && onClick(label)}
        hideIcon={hideIcon}
        disabled={disabled}
      >
        {!hideIcon && <Icon component={icon} size={isSmall ? 2 : 3} />}
        {!isSmall && (
          <Text textAlign='center' fontSize={isSmall ? 0 : 2}>
            {label}
          </Text>
        )}
      </StatusContent>
    </Flex>
  );
};

export default ListingStatusButton;
